// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---
import {Institution} from "../../models/Institution";

interface InstitutionState {
  collection: Record<string, Institution | boolean>;
}

const initialState: InstitutionState = {
  collection: {}
};

const institutionsSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'institutions',
  initialState,
  reducers: {
    showInstitutionCompleted(state, action: PayloadAction<Institution>) {
      if (state.collection[action.payload.id] === true) {
        state.collection = {...state.collection, [action.payload.id]: action.payload};
      }
    },
    showInstitutionFailed(state, action: PayloadAction<string>) {
      if (state.collection[action.payload] === true) {
        state.collection = {...state.collection, [action.payload]: false};
      }
    },
    showInstitutionStarted(state, action: PayloadAction<string>) {
      if (state.collection[action.payload] === undefined) {
        state.collection = {...state.collection, [action.payload]: true};
      }
    }
  }
});

export const {showInstitutionCompleted, showInstitutionFailed, showInstitutionStarted} = institutionsSlice.actions;

export default institutionsSlice.reducer;
